import React from 'react'
import {connect} from "react-redux";
import DataAction from "../../../stores/api/DataAction";

const mapStateToProps = (state, ownProps) => ({
    ...state
});

class Step2 extends React.Component {

    handleOptionClick = (option) => {
        let selectedOptions = this.props.data.selectedOptions
        if(selectedOptions.includes(option)){
            const optionIndex = selectedOptions.indexOf(option)
            if(optionIndex !== -1){
                selectedOptions.splice(optionIndex, 1)
            }
        }else{
            selectedOptions.push(option)
        }
        this.props.dispatch(DataAction.setOptionData(selectedOptions))
    }

    handleRemarkChange = (event) => {
        this.props.dispatch(DataAction.setRemarkData(event.target.value))
    }

    nextStep = () => {
        this.props.dispatch(DataAction.nextStep())
    }

    render() {

        let disableBtn = true

        if ( this.props.data.selectedOptions !== 'undefined' && this.props.data.selectedOptions.length > 0 ) {
            disableBtn = false
        }

        let defaultOptionClass = 'c-appointment__buttons__single'
        if(this.props.data.selectedOptions.includes('Anders namelijk...')){
            defaultOptionClass += ' isActive'
        }

        return (

            <div>
                <header className="c-appointment__header">
                    {this.props.data.wishes.titel &&
                    <h1>{this.props.data.wishes.titel}</h1>
                    }
                    {this.props.data.wishes.tekst &&
                    <p>{this.props.data.wishes.tekst}</p>
                    }
                </header>
                <div className="c-appointment__content-2">
                    <div className="c-appointment__buttons">
                        {this.props.data.wishes.opties.map((data) => {
                            let optionClass = 'c-appointment__buttons__single'
                            if(this.props.data.selectedOptions.includes(data.optie)){
                                optionClass += ' isActive'
                            }
                            return(
                            <button className={optionClass}
                                    onClick={() => this.handleOptionClick(data.optie)}>
                                <img src={data.logo.url} className="optie-logo" alt=""/>
                                <span className="title">{data.optie}</span>
                                <img src={this.props.data.checkmark} alt=""/>
                            </button>)
                        })}
                        <button className={defaultOptionClass} onClick={() => this.handleOptionClick('Anders namelijk...')}>
                            <span>Anders namelijk...</span>
                            <small>Invullen bij het opmerkingen veld</small>
                            <img src={this.props.data.checkmark} alt=""/>
                        </button>
                    </div>
                    <div className="c-appointment__comment c-form">
                        <div className="c-form__row">
                            <div className="c-form__group">
                                <label htmlFor="">Opmerking of aanvullende afspraak (optioneel)</label>
                                <textarea name="" id="" cols="30" rows="5" value={this.props.data.selectedRemark} onChange={this.handleRemarkChange}/>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="c-appointment__footer">
                    <button className="btn btn--rounded btn--beige-dark" onClick={() => this.nextStep()} disabled={disableBtn}><span>Stap 3 - Uw gegevens</span></button>
                </footer>
            </div>

        )

    }

}

export default connect(mapStateToProps)(Step2);
